import React from 'react';
import { useSubscriptionContext } from '@/contexts/SubscriptionContext';
import { Badge } from '@/components/ui/badge';
import { Shield } from 'lucide-react';

export const AdminIndicator: React.FC = () => {
  const { isAdmin } = useSubscriptionContext();

  if (!isAdmin) return null;

  return (
    <Badge variant="secondary" className="bg-yellow-100 text-yellow-800 border-yellow-200 flex items-center gap-1">
      <Shield className="h-3 w-3" />
      Admin
    </Badge>
  );
};

export default AdminIndicator;